import throttle from 'lodash/throttle';
import { FreewheelPlayer } from '@/shared/components/player/freewheel';
import { Deferred } from '@/shared/libs';
import { getLocation } from '@/shared/plugins/stats/helpers';
import { AssetLoader, getSecureUrl } from '@/shared/utils';
import { getDeviceType, getRandomParameters } from './helpers';

export default async ({ $deferredLoader, $oneTrust, $router, $services }, inject) => {
  const info = $services.resolve('info');

  await info.fetch();
  const { freewheelServerUrl, networkId, profile, siteSectionId, siteSectionFallbackId } = info.freeWheelInfo || {};
  $deferredLoader.freewheel = new Deferred();
  $deferredLoader.freewheel.promise.catch(() => {});

  const updateLinkTagParams = () => {
    const deviceType = getDeviceType();
    const location = getLocation();
    const label = $router.currentRoute.params.label || $router.currentRoute.meta.label;
    const csid = siteSectionId
      .replace('$devicetype$', deviceType)
      .replace('$label$', label)
      .replace('$referrer$', location.hostname);
    const { vprn, pvrn } = getRandomParameters();
    const xsId = info.enableMacro ? `&xsId=${$router.currentRoute.query.xsId || '%%CACHEBUSTER%%'}` : '';

    window._fw_linktag_params = {
      scan_delay: 1000,
      allow_rescan_after: 1000,
      server: getSecureUrl(freewheelServerUrl),
      network_id: networkId,
      profile,
      other_global_params: `csid=${csid}&sfid=${siteSectionFallbackId}&vprn=${vprn}&pvrn=${pvrn}&_fw_gdpr=${$oneTrust.gdprApplies}&_fw_gdpr_consent=${$oneTrust.gdprConsent}&flag=+cmpn+fcai${xsId}`,
    };
  };

  inject('freewheel', {
    reload: throttle(() => {
      if (!window._fw_linktag_refresh) {
        return;
      }

      updateLinkTagParams();
      window._fw_linktag_refresh();
    }, 1000, { leading: false }),

    createInstance(opts) {
      return $deferredLoader.freewheel.promise.then(() => {
        if (!window.tv || !window.tv.freewheel || !window.tv.freewheel.SDK) {
          return Promise.reject();
        }

        return new FreewheelPlayer(opts);
      });
    },
  });

  if (!freewheelServerUrl || !networkId || !profile || !siteSectionId) {
    $deferredLoader.freewheel.resolve();
    return;
  }

  Promise.all([
    $deferredLoader.appReady.promise,
    $deferredLoader.oneTrust.promise,
  ])
    .then(() => updateLinkTagParams())
    .then(() => new AssetLoader().load([
      { id: 'freewheel', src: '//mssl.fwmrm.net/libs/adm/6.60.0/AdManager.js' },
      { id: 'linktag', src: '//mssl.fwmrm.net/libs/adm/6.11.0/LinkTag2.js' },
    ]))
    .then(() => $deferredLoader.freewheel.resolve())
    .catch(() => $deferredLoader.freewheel.reject());
};
